export default __webpack_public_path__ + "static/media/innovation-opp-nfo-card-banner-new.9844bde4.png";